/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
// Imports for external libraries go here.
import React, { useEffect, useState } from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { CobrandCardHorizontalFlexible, Types } from '@marriott/mi-ui-library';
import { useClientEnvVarsStore } from '@marriott/mi-store-utils';

import { decodeHtml, getMediaData, getMediaSource } from '../../utils/OfferUtils';
import { shouldUseMockData } from '../../utils/CommonUtils';
import { SECONDARY_MEDIA, PRIMARY_MEDIA } from '../../constants/CommonConstants';
import { ImageRenditionsData } from '../../utils/ImageRenditionStructure';

import { OffersCobrandCardHorizontalFlexibleProps } from './OffersCobrandCardHorizontalFlexible.types';
import { StyledOffersCobrandCardHorizontalFlexible } from './OffersCobrandCardHorizontalFlexible.styles';

export const OffersCobrandCardHorizontalFlexibleWrapperConfig = {
  emptyLabel: 'OffersCobrandCardHorizontalFlexible',
  isEmpty: false,
  resourceType: `mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`,
};

export const OffersCobrandCardHorizontalFlexibleWrapper: React.FC<OffersCobrandCardHorizontalFlexibleProps> = props => {
  const { model, offersData, isAuthorMode } = props;
  const { offersCobrandCarHorizontal } = ImageRenditionsData;
  const { envVarsObject } = useClientEnvVarsStore();
  const imageDomain = envVarsObject?.['UXL_IMAGE_CACHE_DOMAIN'];
  const [mockOffersData, setMockOffersData] = useState<any>({});

  // Load mock data dynamically for dev and author mode
  const GetMockData = async (isAuthorMode: boolean) => {
    if (shouldUseMockData(isAuthorMode)) {
      const mockData = await import('./__mock__/OffersCobrandCardHorizontalFlexible.mock');
      return mockData.mockOffersCobrandCardHorizontalFlexibleData;
    }
    return {};
  };

  useEffect(() => {
    const fetchMockData = async () => {
      const mockData = await GetMockData(isAuthorMode || false);
      setMockOffersData(mockData);
    };

    fetchMockData();
  }, [isAuthorMode]);

  const offersDataNode = !isAuthorMode
    ? offersData?.responseObject?.edges?.[0]
    : mockOffersData.offersData?.responseObject?.edges?.[0];
  const offerType = offersDataNode?.node?.offerType;
  const expectedMediaSource = offerType == 'CoBrand' ? SECONDARY_MEDIA : PRIMARY_MEDIA;
  const mediaSource = isAuthorMode
    ? 'model'
    : getMediaSource(
        offersDataNode?.node?.media,
        expectedMediaSource,
        offersCobrandCarHorizontal?.aspectRatio.dynamicMedia
      );
  const isMediaFromDAC = mediaSource == SECONDARY_MEDIA || mediaSource == PRIMARY_MEDIA;
  const media = isAuthorMode
    ? model?.dynamicMedia
    : getMediaData(offersDataNode?.node?.media, model?.dynamicMedia, mediaSource, expectedMediaSource, imageDomain);
  return (
    <StyledOffersCobrandCardHorizontalFlexible>
      <CobrandCardHorizontalFlexible
        openInNewTab={model?.openInNewTab}
        ctaLink={offersDataNode?.node?.callToActionLink ?? model?.ctaLink}
        ctaLinkText={offersDataNode?.node?.callToActionLabel ?? model?.ctaLinkText}
        header={
          offersDataNode?.merchandisingNode?.headerLong
            ? decodeHtml(offersDataNode?.merchandisingNode?.headerLong)
            : model?.header
        }
        headerTag={model?.headerTag ?? Types.tags.h2}
        styleclass={model?.styleclass}
        descriptionText={
          offersDataNode?.node?.description ? decodeHtml(offersDataNode?.node?.description) : model?.descriptionText
        }
        descriptionTextMobile={decodeHtml(offersDataNode?.node?.descriptionTextMobile ?? '')}
        trackingProperties={model?.trackingProperties}
        dynamicMedia={isMediaFromDAC ? media : model?.dynamicMedia}
        componentId={model?.componentId}
        ctaType={model?.ctaType}
      />
    </StyledOffersCobrandCardHorizontalFlexible>
  );
};

export const OffersCobrandCardHorizontalFlexible = (props: any) => (
  <div
    data-component-name="o-offers-OffersCobrandCardHorizontalFlexible"
    data-testid="cobrand-card-horizontal-flexible"
  >
    <EditableComponent config={OffersCobrandCardHorizontalFlexibleWrapperConfig} {...props}>
      <OffersCobrandCardHorizontalFlexibleWrapper {...props} />
    </EditableComponent>
  </div>
);
